module.exports = __webpack_public_path__ + "static/media/m253.587b21a8.webp";